import "./CommonsCapacities.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  CapacitiesRaw,
  CommonsCapacitiesMessages,
  PageSetting,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/commonsCapacities/get-commonsCapacities-actions";
import { findById } from "../../../../controllers/store/actions/commonsCapacities/update-commonsCapacities-actions";
import { remove } from "../../../../controllers/store/actions/commonsCapacities/delete-commonsCapacities-action";
import { clear } from "../../../../controllers/store/actions/commonsCapacities/create-commonsCapacities-action";
import NewCommonsCapacitiesModal from "../../../components/Forms/Modal/CommonsCapacities/NewCommonsCapacities";
import UpdateCommnosCapacitiesModal from "../../../components/Forms/Modal/CommonsCapacities/UpdateCommonsCapacities";
import { useParams } from "react-router-dom";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;
const formatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "COP", // Cambia a 'USD', 'COP', etc., según la moneda que necesites.
});
const query: Query = { filter: {} };
const CommonsCapacities: React.FC = () => {
  const { capacity } = useParams();
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [title, setTitle] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const CommonsCapacitiesState = useSelector(
    (state: any) => state.commonsCapacities
  );
  const updatedCommonsCapacitiesState = useSelector(
    (state: any) => state.updatedCommonsCapacities
  );
  const CapacitiesTypeState = useSelector(
    (state: any) => state.capacitiesTypes
  );
  const deletedCommonsCapacitiesState = useSelector(
    (state: any) => state.deletedCommonsCapacities
  );
  const createdCommonsCapacitiesState = useSelector(
    (state: any) => state.createdCommonsCapacities
  );
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const columns: TableProps<CapacitiesRaw>["columns"] = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
    },
    {
      title: "Beneficiario",
      dataIndex: "beneficiario",
      key: "beneficiario",
    },
    {
      title: "Identidad",
      dataIndex: "identidad",
      key: "identidad",
    },
    {
      title: "Beneficios que genera",
      dataIndex: "beneficios_que_genera",
      key: "beneficios_que_genera",
    },
    {
      title: "Características de productos y servicios que genera",
      dataIndex: "caracteristicas_de_productos_yo_servicios_que_genera",
      key: "caracteristicas_de_productos_yo_servicios_que_genera",
    },
    {
      title: "Grado de madurez de la solucion de la capacidad",
      dataIndex: "grado_de_madurez_de_la_solucion_capacidad",
      key: "grado_de_madurez_de_la_solucion_capacidad",
    },
    {
      title: "Descripción detallada",
      dataIndex: "descripcion_detallada",
      key: "descripcion_detallada",
    },
    {
      title: "Problemas que soluciona",
      dataIndex: "problemas_que_soluciona",
      key: "descripcion_detallada",
    },
    {
      title: "Presupuesto",
      dataIndex: "presupuesto",
      key: "presupuesto",
      render(value, record, index) {
        return formatter.format(parseInt(value || 0));
      },
    },
    {
      title: "Área general",
      dataIndex: "area_de_conocimiento",
      key: "area_de_conocimiento",
    },

    {
      title: "Área especifica",
      dataIndex: "especialidad_de_conocimiento",
      key: "especialidad_de_conocimiento",
    },

    {
      title: "Gran área del conocimiento",
      dataIndex: "gran_area_de_conocimiento",
      key: "gran_area_de_conocimiento",
    },

    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: CapacitiesRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: CommonsCapacitiesMessages.Title,
                content:
                  CommonsCapacitiesMessages.CommonsCapacitiesConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedCommonsCapacitiesMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: CommonsCapacitiesMessages.Title,
      description: CommonsCapacitiesMessages.CommonsCapacitiesCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedCommonsCapacitiesMessage = () => {
    api["success"]({
      key: 1,
      message: CommonsCapacitiesMessages.Title,
      description:
        CommonsCapacitiesMessages.CommonsCapacitiesDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedCommonsCapacitiesMessage = () => {
    api["success"]({
      key: 1,
      message: CommonsCapacitiesMessages.Title,
      description:
        CommonsCapacitiesMessages.CommonsCapacitiesrUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    query.filter.capacity_type = `${capacity}`;
    dispatch(find(PageSetting.page, pageSize, query));
    setInitialDataLoaded(true);
  }, [pageSize, capacity]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="commonsCapacities-layout">
      {contextHolder}
      {createdCommonsCapacitiesState.createdCommonsCapacities
        ? showCreatedCommonsCapacitiesMessageSuccess()
        : null}
      {deletedCommonsCapacitiesState.removed
        ? showDeletedCommonsCapacitiesMessage()
        : null}
      {updatedCommonsCapacitiesState.updatedCommonsCapacities
        ? showUpdatedCommonsCapacitiesMessage()
        : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="commonsCapacities-content">
        <Card className="commonsCapacities-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            {capacity && CapacitiesTypeState?.list.length > 0 ? (
              <h1 className="heading-content-title">
                Capacidades
                <span className="heading-content-subtitle">
                  {
                    CapacitiesTypeState?.list.find(
                      (e: any) => e.id === parseInt(capacity)
                    )?.capacities
                  }
                </span>
              </h1>
            ) : null}
            <br />
          </Col>
          <NewCommonsCapacitiesModal
            capacityType={capacity}
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateCommnosCapacitiesModal
            capacityType={capacity}
            commonsCapacities={updatedCommonsCapacitiesState.commonsCapacities}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />

          {!initialDataLoaded && CommonsCapacitiesState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes capacidades aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar capacidad
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="large"
                      icon={<PlusOutlined />}
                    >
                      Agregar capacidad
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={CommonsCapacitiesState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 3500 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      CommonsCapacitiesState.meta?.total_count ||
                      CommonsCapacitiesState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={CommonsCapacitiesState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default CommonsCapacities;
